import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  root: _objectSpread({
    width: '100%',
    height: 'calc(100% - 40px)',
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    overflow: 'auto',
    padding: '16px 0',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.primary.white
  }, theme.utils.scrollbar),
  emptyView: {
    maxWidth: 340,
    textAlign: 'center',
    margin: [0, 'auto'],
    illustration: {
      maxHeight: 144,
      height: '18vh',
      marginBottom: 14,
      '& .fm-entity-list__empty-first-icon': {
        width: 80,
        display: 'inline-block'
      }
    }
  },
  emptyViewLast: {
    maxWidth: 440,
    textAlign: 'center',
    margin: [0, 'auto'],
    '& img': {
      width: '100%',
      maxWidth: '100%',
      borderRadius: 25,
      boxShadow: '0 1px 8px 0 rgba(39, 60, 80, 0.2), 0 3px 4px 0 rgba(39, 60, 80, 0.12), 0 3px 3px 0 rgba(39, 60, 80, 0.14)',
      cursor: 'pointer',
      marginBottom: 24
    }
  },
  title: {
    marginBottom: 8
  },
  description: {
    marginBottom: 24
  },
  button: {
    marginRight: 8,
    marginBottom: 8,
    display: 'inline-block',
    '&:last-child': {
      marginRight: 0
    }
  }
});